import { getPrefixUrl, ModuleNames } from 'utils/apiClient/url';
import ownFetch from '../../utils/own-fetch';
import { setCustomHeaders } from '../../utils/api';

// eslint-disable-next-line import/prefer-default-export
export function fetchPusherKey({ userToken }: { userToken: string }) {
  const customHeaders = setCustomHeaders(userToken);
  return ownFetch(
    `${getPrefixUrl(ModuleNames.EVENT_MANAGER)}/auth`,
    'POST',
    null,
    customHeaders
  );
}
